<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'NormConsumption',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'Date',
        caption: 'Дата',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
        width: 100,
        groupIndex: 1,
      }, {
        dataField: 'ObjectName',
        caption: 'Объект',
        alignment: 'left',
        groupIndex: 0,
      }, {
        caption: 'Время запуска',
        dataField: 'Begin',
        alignment: 'left',
        width: 110,
        customizeText: params => new Date(params.value * 1000).toLocaleTimeString('ru', { timeZone: 'UTC' }),
      }, {
        caption: 'Время остановки',
        dataField: 'End',
        alignment: 'left',
        width: 130,
        customizeText: params => new Date(params.value * 1000).toLocaleTimeString('ru', { timeZone: 'UTC' }),
      }, {
        caption: 'Продолжительность работы',
        dataField: 'Duration',
        alignment: 'left',
        width: 190,
      }, {
        caption: 'Расход по норме, л',
        dataField: 'Consumption',
        alignment: 'left',
      }],
      summaryFields: [{
        column: 'Begin',
        displayFormat: 'Итого:',
      }, {
        column: 'Duration',
        name: 'Duration',
        showInColumn: 'Duration',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'Consumption',
        name: 'Consumption',
        showInColumn: 'Consumption',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      rowClick: null,
      reportSummary: [],
      summary: null,
      reportConverted: null,
      index: 0,
    };
  },
  watch: {
    reportData (value) {
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      } else {
        this.reportData.Data.Data.Rows = this.convertRows(value.Data.Data.Rows);
      }
      this.totalConsumption = null;
      this.totalDuration = null;
      this.updateSummary();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    } else {
      this.reportData.Data.Data.Rows = this.convertRows(this.reportData.Data.Data.Rows);
    }
    this.totalConsumption = null;
    this.totalDuration = null;
    this.updateSummary();
  },
  methods: {
    sumTimes (a, b) {
      const t1 = a.split(':').map(x => Number(x));
      const t2 = b.split(':').map(x => Number(x));
      const t3 = [t1[0] + t2[0], t1[1] + t2[1], t1[2] + t2[2]];
      if (t3[2] >= 60) {
        t3[2] -= 60;
        t3[1] += 1;
      }
      if (t3[1] >= 60) {
        t3[1] -= 60;
        t3[0] += 1;
      }
      return t3.map(x => (x >= 10 ? '' : '0') + x).join(':');
    },
    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((items) => {
        items.Rows.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
      });
      this.reportSummary = this.convertRows(rows);
    },
    convertRows (data) {
      const rows = [];
      data.forEach((x) => {
        if (!('Rows' in x)) {
          rows.push(x);
          return;
        }
        const raw = {
          Date: x.Date,
          ObjectName: x.ObjectName,
          RowNum: x.RowNum,
        };
        x.Rows.forEach((row) => {
          rows.push({ ...raw, ...row });
        });
      });
      return rows;
    },
    updateSummary () {
      this.summary = {
        calculateCustomSummary: (options) => {
          const varoptions = options;
          if (varoptions.summaryProcess === 'start') {
            if (varoptions.name === 'Duration') {
              varoptions.totalValue = '00:00:00';
            } else if (varoptions.name === 'Consumption') {
              varoptions.totalValue = 0;
            }
          } else if (varoptions.summaryProcess === 'calculate' && varoptions.value !== undefined) {
            if (varoptions.name === 'Duration') {
              varoptions.totalValue = this.sumTimes(varoptions.totalValue, varoptions.value);
            } else if (varoptions.name === 'Consumption') {
              varoptions.totalValue += varoptions.value;
            }
          } else if (varoptions.summaryProcess === 'finalize') {
            if (varoptions.name === 'Consumption') {
              varoptions.totalValue = Math.round(varoptions.totalValue * 10000) / 10000;
            }
          }
        },
        groupItems: this.summaryFields.filter(x => x.column !== 'Begin'),
        totalItems: this.summaryFields,
      };
    },
  },
};
</script>
